import { makeMatch } from 'ts-adt/MakeADT'

export const match = makeMatch('type')
